// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1tsOd","search":"Settings_search__3JyLn","filter":"Settings_filter__3eKOJ"};